/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Rater = new Class({
	Implements: [Events, Options],
	options: {
		max_size: 0,	//height or width
		min_size: 0,	//height or width === don't need to specify, if 'size' in this options is absolute
		max_data: 0,	//max value through the elements === optional
		min_data: 0,	//min value through the elements === optional
		property: 'data-height', //property of the elements where to take data
		animate: true,
		duration: 500,
		equal_speed: true,	//if false, all animations will finish at the same time (duration),
												//if true, the speed for each animation is the same, so the smallest element will finish first
		transition: Fx.Transitions.linear,
		type: 'vertical', //vertical or horisontal
		size: 'absolute',	//absolute or relative
											//IMPORTANT!: don't use 'relative' sizing if there is a possibility of negative values !!!!!!!!!!!!
											//if absolute, the size of each element counts from 0
											//i.e. - max_size is 100px,
											//and you have 5 elements with 'data-height's {20, 40, 60, 80, 100},
											//so, their sizes are going to be - {20, 40, 60, 80, 100}.
											//if relative, the size of each element counts from min_height
											//i.e. - max_size is 100px, min_size is 60px, and you have the same elements,
											//so, their sizes are going to be - {60, 70, 80, 90, 100}
		calculate_even_one_element: false //can be helpful when you use lazyLoader (in this case set to 'true')
	},

	initialize: function(_elements, options){
		this._elements = _elements;

		if(this._elements){
			this.setOptions(options);
			this.build();
		}
	},

	build: function(){
		var opts = this.options;

		if(this._elements.length == 0 || (this._elements.length == 1 && !opts.calculate_even_one_element)) return;

		this.max_data = opts.max_data;
		this.min_data = opts.min_data;
		this.has_negative = (this.max_data < 0 || this.min_data < 0);

		if(opts.type == 'vertical'){
			this.max_size = (opts.max_size == 0) ? this._elements[0].getSize().y : opts.max_size;
		}else{
			this.max_size = (opts.max_size == 0) ? this._elements[0].getSize().x : opts.max_size;
		}

		if(this.max_size > 0){
			opts.max_size = this.max_size;

			if(opts.animate == true){
				if(opts.type == 'vertical'){
					this._elements.each(function(_el){
						_el.setStyle('height', 0);
					});
				}else{
					this._elements.each(function(_el){
						_el.setStyle('width', 0);
					});
				}
			}

			if(!this.max_data || this.max_data == 0){
				this.get_values();
			}

			if(!(this.max_data == 0 && this.min_data == 0)){
				this.calculate_size();
				this.set_size();
			}
		}
	},

	get_values: function(){
		this._elements.each(function(_el){
			var data = _el.getAttribute(this.options.property).toFloat() || 0;

			if(data > this.max_data){
				this.max_data = data;
			}

			if(this.min_data > data || this.min_data == 0){
				this.min_data = data;
			}

			if(data < 0){
				this.has_negative = true;
			}
		}.bind(this));
	},

	calculate_size: function(){
		var opts = this.options;

		if(this.options.size == 'relative'){
			var data_diff = this.max_data - this.min_data,
					size_diff = opts.max_size.toInt() - opts.min_size.toInt();

			this._elements.each(function(_el){
				var data = _el.getAttribute(opts.property).toFloat(),
						this_size = opts.max_size;

				if(data_diff > 0){
					this_size = opts.min_size + (data - this.min_data) * size_diff / data_diff;
				}

				_el.setAttribute('data-size', this_size);
			}.bind(this));

			if(this.min_data < 0){
				console.warn("Don't use 'relative' sizing with negative values!");
			}
		}else{
			if(this.max_data > 0 && this.min_data >=0){
				this._elements.each(function(_el){
					var data = _el.getAttribute(opts.property).toFloat();
					data = (data > this.max_data)? this.max_data : data;

					var this_size = data * opts.max_size / this.max_data;

					_el.setAttribute('data-size', this_size);
				}.bind(this));
			}else if(this.max_data <=0 && this.min_data < 0){
				this._elements.each(function(_el){
					var data = _el.getAttribute(opts.property).toFloat();
					data = (data > this.max_data)? this.max_data : data;

					var this_size = data * opts.max_size / this.min_data * -1;

					_el.setAttribute('data-size', this_size);
				}.bind(this));
			}else if(this.max_data > 0 && this.min_data < 0){
				var count_data = this.max_data + this.min_data * -1,
						shift = (this.min_data * opts.max_size / count_data) * -1;

				if(opts.type == 'vertical'){
					this._elements.each(function(_el){
						var _parent = _el.getParent();
						_parent.setStyle('height', _parent.getSize().y - shift);

						var data = _el.getAttribute(opts.property).toFloat();
						data = (data > this.max_data)? this.max_data : data;

						var this_size = data * opts.max_size / count_data;

						_el.setAttribute('data-size', this_size);
					}.bind(this));
				}else{
					this._elements.each(function(_el){
						var _parent = _el.getParent();

						_parent.setStyles({
							'margin-left': shift,
							'width': _parent.getSize().x - shift
						});

						var data = _el.getAttribute(opts.property).toFloat();
						data = (data > this.max_data)? this.max_data : data;

						var this_size = data * opts.max_size / count_data;

						_el.setAttribute('data-size', this_size);
					}.bind(this));
				}
			}
		}
	},

	set_size: function(){
		var _this = this;
		var opts = this.options;

		if(this.has_negative){
			opts.animate = false;

			if(this.max_data <= 0){
				this._elements.each(function(_el){
					var _parent = _el.getParent();

					if(opts.type == 'vertical'){
						_parent.setStyle('height', 'auto');
					}
				}.bind(this));
			}
		}

		if(opts.animate == true){
			this._elements.each(function(_el){
				var size = _el.getAttribute('data-size').toFloat(),
					this_time = (opts.equal_speed == true) ? size * opts.duration / opts.max_size : opts.duration,
					animate = new Fx.Morph(_el, { duration: this_time, transition: opts.transition });

				if(opts.type == 'vertical'){
					animate.start({ 'height': [0, size] });
				}else{
					animate.start({ 'width': [0, size] });
				}

				(function(){
					animate = null;
				}).delay(this_time);
			});

			(function(){
				_this.fireEvent('animationDone');
			}).delay(opts.duration);
		}else{
			this._elements.each(function(_el){
				var size = _el.getAttribute('data-size').toFloat(),
						shift = 0;

				if(size < 0){
					shift = size;
					size *= -1;
				}

				if(opts.type == 'vertical'){
					_el.setStyles({
						'height': size,
						'bottom': shift
					});
				}else{
					_el.setStyles({
						'width': size,
						'left': shift
					});
				}
			});
		}

		this.fireEvent('sizeSet');
	}
});
